import * as ActionTypes from "../action-types";

const vehicleECULog_defaultState = {
    byID: {},
    logByVID: {},
    allIDs: []
}

export const vehicleECULogs = (
    state = vehicleECULog_defaultState,
    action
) => {
    let newState = JSON.parse(JSON.stringify(state));

    if(!action) return newState

    switch (action.type) {
        case ActionTypes.GET_TIMEFRAME_VEHICLE_ECU_LOGS: {

            const vehicleECULogs = action.vehicleECULogs

            const vid = action.vid
            const startTime = action.startTime
            const endTime = action.endTIme

            newState.byID[vid] = [startTime, endTime]

            newState.logByVID[vid] = vehicleECULogs.sort((a,b) => a.vehicleTime-b.vehicleTime)
            
            if(!newState.allIDs.includes(vid)) newState.allIDs.push(vid)
            
            return newState;
        }
        default: {
            return state;
        }
    }
};
